"use client";

import { ShoppingCartIcon } from "@/features/cart/ui";
import { SearchBar } from "@/features/search/ui";
import { UserAccountNav } from "@/features/user/ui";
import { Link } from "@/i18n/navigation";
import { Box, HStack, Separator, Text, VStack } from "@/ui";
import { LanguageSelector } from "./LanguageSelector";
import { MobileDropdownNav } from "./MobileDropdownNav";
import {
  getMobileSearchBarContainerClassName,
  getMobileSearchBarRowClassName,
} from "./searchBarLayout";

/**
 * MobileNav component - Mobile navigation layout
 * Luxury styling: refined logo, minimal spacing
 */
export const MobileNav = () => {
  return (
    <VStack className="w-full md:hidden gap-2">
      <HStack className="w-full items-center justify-between">
        <Link href="/">
          <Text className="font-serif text-2xl font-medium tracking-tight text-foreground">
            TUTULY
          </Text>
        </Link>
        <HStack className="items-center gap-1">
          <LanguageSelector />
          <ShoppingCartIcon />
          <UserAccountNav />
          <MobileDropdownNav />
        </HStack>
      </HStack>
      <Separator className="bg-border/30" />
      <HStack className={getMobileSearchBarRowClassName()}>
        <Box className={getMobileSearchBarContainerClassName()}>
          <SearchBar />
        </Box>
      </HStack>
    </VStack>
  );
};
